import { PreviewTable } from './components';
import { usePatientsTable } from './hooks/usePatientsTable.ts';

interface IPatientsTableProps {
  groupName?: string;
  footerWidth?: string | number;
  isLoading?: boolean;
}

export const PatientsTable = ({
  groupName,
  footerWidth,
  isLoading,
}: IPatientsTableProps) => {
  const {
    entries,
    columns,
    totalCount,
    isLoading: loading,
    filters,
    onFilterChange,
  } = usePatientsTable(groupName);

  return (
    <PreviewTable
      rows={entries}
      columns={columns}
      filters={filters}
      setFilters={onFilterChange}
      totalCount={totalCount}
      loading={isLoading || loading}
      type='patients'
      displayHead={true}
      footerWidth={footerWidth}
    />
  );
};
